var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{staticClass:"py-16 tablet:p-48 desktop:p-56 desktop:mx-auto desktop:max-w-1440",class:[_vm.data.class, _vm.data.staticClass]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }